import styled from "styled-components";
import {
  Wifi,
  Dumbbell,
  Waves,
  Shield,
  BedDouble,
  Utensils,
} from "lucide-react";
import {
  Container,
  SectionHeader,
  Subtitle,
  Title,
  Description,
} from "./Section";

const FacilitiesSection = styled.section`
  padding: 120px 24px;
  background: linear-gradient(180deg, #faf8f5 0%, #f5f2ed 100%);
  position: relative;

  @media (max-width: 768px) {
    padding: 80px 24px;
  }
`;

const FacilitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 968px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const FacilityCard = styled.div`
  background: #ffffff;
  padding: 50px 36px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e5e1dc;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #c9a86c, #8b7355);
    transform: scaleX(0);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    transform: translateY(-12px);
    box-shadow: 0 25px 60px rgba(0, 0, 0, 0.1);

    &::before {
      transform: scaleX(1);
    }
  }
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  background: #faf8f5;
  border: 1px solid #e5e1dc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 28px;
  color: #8b7355;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  ${FacilityCard}:hover & {
    background: #1a1a1a;
    border-color: #1a1a1a;
    color: #c9a86c;
  }
`;

const FacilityTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
  letter-spacing: 0.5px;
`;

const FacilityDesc = styled.p`
  font-size: 14px;
  color: #8b7355;
  line-height: 1.8;
  font-weight: 400;
`;

const Facilities = () => {
  const facilities = [
    {
      icon: <BedDouble size={36} />,
      title: "Rooms and Suites",
      description:
        "Varied types of rooms, from standard to luxury suites, equipped with modern essentials.",
    },
    {
      icon: <Shield size={36} />,
      title: "24-Hour Security",
      description:
        "On-site security personnel and best surveillance with secure storage for valuables.",
    },
    // {
    //   icon: <Dumbbell size={36} />,
    //   title: "Fitness Center",
    //   description:
    //     "Equipped with modern exercise machines and weights for your workout needs.",
    // },
    {
      icon: <Waves size={36} />,
      title: "Swimming Pool",
      description:
        "Indoor and outdoor pools for leisure or exercise with stunning city views.",
    },
    {
      icon: <Wifi size={36} />,
      title: "High-Speed WiFi",
      description:
        "Complimentary high-speed internet access throughout the property.",
    },
    {
      icon: <Utensils size={36} />,
      title: "Restaurant & Bar",
      description:
        "On-site dining with local and international cuisine, open all day.",
    },
  ];

  return (
    <FacilitiesSection id="facilities">
      <Container>
        <SectionHeader>
          <Subtitle>Amenities</Subtitle>
          <Title>
            Hotel <strong>Facilities</strong>
          </Title>
          <Description>
            Experience world-class amenities designed for your comfort and
            convenience
          </Description>
        </SectionHeader>

        <FacilitiesGrid>
          {facilities.map((facility, index) => (
            <FacilityCard key={index}>
              <IconContainer>{facility.icon}</IconContainer>
              <FacilityTitle>{facility.title}</FacilityTitle>
              <FacilityDesc>{facility.description}</FacilityDesc>
            </FacilityCard>
          ))}
        </FacilitiesGrid>
      </Container>
    </FacilitiesSection>
  );
};

export default Facilities;
